import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'

import { useMutation } from '@apollo/client'
import { MC_VTY } from 'graphql/mutations'
import styles from '../vehicleType.module.scss'

const VehicleType = ({ setCreate, update, loading }) => {
  const [vTypIcon, setVTypIcon] = useState()
  const [vTypIconDetails, setVtypIconDtails] = useState('')
  const [vTyp, setVTyp] = useState('')

  const [call] = useMutation(MC_VTY)

  const onSubmit = () => {
    loading(true)
    setCreate(false)
    call({
      variables: {
        icon: vTypIcon,
        iconDetails: vTypIconDetails,
        vehicleType: vTyp,
      },
    })
      .then(res => {
        update()
      })
      .catch(err => console.error(err))
  }

  return (
    <div className={styles.vTypeFormRoot}>
      <div className={styles.formWrapper}>
        <TextField
          autoFocus
          margin="dense"
          id="vehicle type"
          label="Vehicle Type"
          type="text"
          value={vTyp}
          onChange={e => setVTyp(e.target.value)}
          fullWidth
        />{' '}
        <Button
          autoFocus
          margin="dense"
          id="Vehicle Type Icon"
          label="Vehicle Type Icon"
          type="file"
          accept=".svg"
          variant="contained"
          component="label"
          className={styles.selectButton}
        >
          Select Vehicle type icon
          <input
            type="file"
            onChange={e => {
              setVTypIcon(e.target.files.item(0))
            }}
            accept=".svg"
          />
        </Button>
        <TextField
          // vmn_details
          autoFocus
          margin="dense"
          id="iconDetail"
          label="IconDetail"
          type="text"
          fullWidth
          value={vTypIconDetails}
          onChange={e => setVtypIconDtails(e.target.value)}
        />{' '}
        <Button
          variant="contained"
          onClick={() => onSubmit()}
          className={styles.submit}
          color="primary"
        >
          Submit
        </Button>
      </div>
    </div>
  )
}

export default VehicleType
